import { Settings, Bot } from 'lucide-react';
import type { HubSection } from '@/components/layout/HubLayout';

export const ORGANIZATION_HUB_SECTIONS: HubSection[] = [
  {
    id: 'general',
    label: 'General settings',
    icon: Settings,
    description: 'Organization name, slug, and sandbox defaults.',
    permission: 'org:read',
  },
  {
    id: 'service-accounts',
    label: 'Service accounts',
    icon: Bot,
    description: 'Machine identities and their API keys.',
    permission: 'service-accounts:read',
  },
];

export const DEFAULT_ORGANIZATION_HUB_SECTION = 'general';

export function organizationHubSection(id: string): HubSection | undefined {
  return ORGANIZATION_HUB_SECTIONS.find((s) => s.id === id);
}
